/**
 * Login and registration translations
 * Includes: Login form, third-party login, registration process, authentication
 */
export default {
  success: 'Login successful!', // ✅
  failed: 'Login failed, please try again', // ✅
  pleaseCheckAgreement: 'Please check the agreement first', // ✅
  processing: 'Logging in...',
  webviewNotSupported: 'Login not supported in embedded browser', // ✅
  signInWithGoogle: 'Sign in with Google', // ✅
  continueWithApple: 'Continue with Apple', // ✅
  termsText: 'I certify I have read and agree to the {terms} and confirm that you have read {privacy}. I certify I am at least 18-years old and have reached the age of majority where I live.', // ✅
  termsOfService: 'Terms Of Service', // ✅
  privacyPolicy: 'Privacy Policy', // ✅
  // Authentication
  authenticating: 'Authenticating...', // ✅
  loadSDKFailed: 'Failed to load {name} Services', // ✅
  initializing: 'Initializing {name} Services...',
  logoutFailed: 'Failed to cancel {name} authorization', // ✅
  authenticationFailed: '{name} authorization failed', // ✅
  authCancelled: 'Authorization cancelled', // ✅
  stateValidationFailed: 'State validation failed', // ✅
  invalidOAuthRedirect: 'Invalid OAuth redirect', // ✅
  codeVerifierNotFound: 'codeVerifier not found', // ✅
  popupBlocked: 'Popup blocked', // ✅
}
